import { Component } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { AntiFraudService } from 'src/app/facade/anti-fraud/anti-fraud.service';
import { switchMap } from 'rxjs/operators';

@Component({
	selector: 'app-scenario-fourth-results',
	templateUrl: './scenario-fourth-results.component.html',
	styleUrls: ['./scenario-fourth-results.component.scss']
})
export class ScenarioFourthResultsComponent {
	registrationPlatesVinNumber;
	platesVinResults;
	loading = false;

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private antiFraudService: AntiFraudService
	) {}

	ngOnInit() {
		this.route.params
			.pipe(
				switchMap(async (param: Params) => {
					this.registrationPlatesVinNumber = param.registrationPlatesVinNumber;
					if (
						this.registrationPlatesVinNumber === null ||
						this.registrationPlatesVinNumber === undefined
					) {
						this.router.navigate(['/scenario-four']);
					}
					this.getAntiFraudByRegistrationPlatesVinNumber(
						this.registrationPlatesVinNumber
					);
				})
			)
			.subscribe(item => {});
	}

	getAntiFraudByRegistrationPlatesVinNumber(registrationPlatesVinNumber) {
		this.antiFraudService
			.getAntiFraudByRegistrationPlatesVinNumber(registrationPlatesVinNumber)
			.subscribe(
				result => {
					console.log(result.data['getAntiFraudByRegistrationPlatesVinNumber']);

					this.platesVinResults =
						result.data['getAntiFraudByRegistrationPlatesVinNumber'];
				},
				error => {
					console.log(error);
					this.platesVinResults = null;
				}
			);
	}

	saveNameForm(registrationPlatesVinNumber) {}
}
